import '@babel/polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//pinia仓库
import stores from './stores'
import './icons/index'
import './styles/index.scss'
import setLoading from './utils/load'
import './utils/auth'
import './utils/permission'
import i18n from './locale/index'
import './utils/vconsole'
import vant from '@/components/Vant'
// eslint-disable-next-line
import FastClick from "fastclick"
FastClick.prototype.focus = (targetElement: any) => {
  let length
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' &&
    targetElement.type !== 'month'
  ) {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.setSelectionRange(length, length)
  }
}
FastClick.attach(document.body)
import "video.js/dist/video-js.css";
const app = createApp(App)
app.use(store)
//pinia仓库
app.use(stores)
app.use(router)
app.use(vant)
app.use(i18n)
app.mount('#app')
app.config.globalProperties.$Loading = setLoading
